export default "__VITE_ASSET__DF4K6N7w__"